module.exports = __webpack_public_path__ + "img/inProIcon.32040714.svg";